// Fields, defaults, and library info for this section. The editor builds its form from `fields`.
const definition = {
  order: 130,
  type: "review_slider",
  name: "Review slider",
  category: "Content",
  description: "Customer quotes that slide across the home page",
  defaultSettings: {
    heading: "What customers say",
    subtitle: "",
    autoplay: true,
    reviews: [
      {
        id: "review_sample_1",
        name: "Ayesha K.",
        detail: "Karachi",
        quote: "The scent lasts through the day and the bottle arrived packed with care.",
        rating: 5,
      },
      {
        id: "review_sample_2",
        name: "Hassan R.",
        detail: "Lahore",
        quote: "I ordered a second bottle after the first one. The notes match the description.",
        rating: 5,
      },
      {
        id: "review_sample_3",
        name: "Sara M.",
        detail: "Islamabad",
        quote: "Cash on delivery was simple, and the fragrance is exactly what I wanted.",
        rating: 4,
      },
    ],
  },
  fields: [
    { key: "heading", label: "Heading", type: "text" },
    { key: "subtitle", label: "Subtitle", type: "text" },
    { key: "autoplay", label: "Slide on its own", type: "toggle" },
    {
      key: "reviews",
      label: "Reviews",
      type: "blocks",
      itemName: "review",
      hint: "Each review is one card. Shoppers can slide through them on the home page.",
      summary: { title: "name", text: "quote" },
      defaultItem: { name: "Customer", detail: "", quote: "", rating: 5 },
      fields: [
        { key: "name", label: "Customer name", type: "text" },
        { key: "detail", label: "Detail", type: "text", placeholder: "City or product" },
        { key: "quote", label: "Quote", type: "textarea" },
        {
          key: "rating",
          label: "Stars",
          type: "select",
          options: [5, 4, 3, 2, 1].map((value) => ({ value: String(value), label: `${value} stars` })),
        },
      ],
    },
  ],
};

export default definition;
